import useScreenSize from '@/hooks/useScreenSize';
import useTranslations from '@/i18n/useTranslations';
import TextHandler from '@/shared-components/text/components/TextHandler';

import './styles/Description.css';

export default function Description({ artworkData }) {
  const t = useTranslations('common.shared.artwork_view.description');
  const screenSize = useScreenSize();
  const threshold = calculateThreshold();

  function calculateThreshold() {
    if(screenSize.width <= 370) return 90;
    if(screenSize.width <= 400) return 100;
    if(screenSize.width <= 450) return 115;
    if(screenSize.width <= 485) return 130;
    if(screenSize.width <= 520) return 140;
    if(screenSize.width <= 610) return 153;
    if(screenSize.width <= 680) return 170;
    if(screenSize.width <= 730) return 182;
    if(screenSize.width <= 815) return 205;
    if(screenSize.width <= 900) return 225;
    else return 200;
  }

  return (
    <TextHandler
      className="artwork-view-artwork-description__text"
      controlsClassName="artwork-view-artwork-description__more-button"
      text={artworkData.artwork_about.artwork_description}
      maxCharactersWhenCollapsed={threshold}
      collapsable
      moreLabel={t('more')}
      lessLabel={t('less')}
    />
  );
}
